export default __webpack_public_path__ + "static/media/map-side-nodata.50e31ba2.svg";